import React, { useMemo } from 'react';
import { Avatar, Box, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/authContext';
import { generateUniqueColor } from '../../../util/colorUtil';

const UserAvatar = () => {
  const { currentUser, isLoggedIn } = useAuth();

  if (!isLoggedIn || !currentUser || !currentUser.userName) {
    return null;
  }

  const firstLetter = currentUser.userName.charAt(0).toUpperCase();

  // Memoize the avatar color - only calculate once when component mounts
  const avatarColor = useMemo(() => {
    return generateUniqueColor(currentUser.userId);
  }, [currentUser.userId]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip title={`Angemeldet als ${currentUser.userName}`} arrow>
        <Link to='/settings' style={{ textDecoration: 'none' }}>
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: avatarColor,
              color: 'white',
              fontSize: '14px',
              fontWeight: 'bold',
              border: '2px solid white',
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.8,
              },
            }}
          >
            {firstLetter}
          </Avatar>
        </Link>
      </Tooltip>
    </Box>
  );
};

export default UserAvatar;
